import { useConfigCatClient } from 'configcat-react';
import { useEffect } from 'react';
import { useProfileV2 } from '#lib/Profile';
import { useFlagsContext } from './ConfigCatFlags';

export default function InitConfigCat() {
  return <ConfigCatBootStrap />;
}

function ConfigCatBootStrap() {
  const configCatClient = useConfigCatClient();
  const { basicProfile } = useProfileV2();
  const { setFlagsReady, setFlagsError } = useFlagsContext();

  useEffect(() => {
    let canceled = false;

    const init = async () => {
      try {
        setFlagsReady(false);
        setFlagsError(false);

        if (basicProfile?.email) {
          const normalizedEmail = basicProfile.email.toLowerCase();

          configCatClient.setDefaultUser({
            identifier: normalizedEmail,
            email: normalizedEmail,
          });
        }

        await configCatClient.waitForReady();

        if (canceled) {
          return;
        }

        const refreshResult = await configCatClient.forceRefreshAsync();

        if (!refreshResult.isSuccess) {
          setFlagsError(true);

          return;
        }

        const keys = configCatClient.snapshot().getAllKeys();

        if (keys.length === 0) {
          setFlagsError(true);

          return;
        }

        setFlagsReady(true);
      } catch {
        if (!canceled) {
          setFlagsError(true);
        }
      }
    };

    void init();

    return () => {
      canceled = true;
    };
  }, [basicProfile?.email, configCatClient, setFlagsError, setFlagsReady]);

  return null;
}
